import React from 'react'

import { useFetch } from 'hooks'
import { jobsAPI } from 'features/job/api'
import { RequestUtils } from 'utils'

export const useEmployerJobsFetch = () => {
  const { data, fetch, loading, error, resetState } = useFetch()

  const onFetch = params => {
    let requestParams = {}

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    fetch(jobsAPI.getJobs, requestParams)
  }

  return {
    data,
    loading,
    error,
    onFetch,
    resetState,
  }
}
